import axios from 'axios';
import { axiosBaseUrl } from './client';

export interface VisitType {
  type: 'video' | 'chat' | 'onsite';
  price: number | null;
  visitLengthMinutes: number;
  categories: string[];
}

export const visitTypesApi = {
  getAllVisitTypes: (): Promise<{ data: VisitType[] }> =>
    axios.get(`${axiosBaseUrl}/visit/types`),

  getVisitTypesByCategory: (category: string): Promise<{ data: VisitType[] }> =>
    axios.get(`${axiosBaseUrl}/visit/types/by-category`, {
      params: { category },
    }),

  getCategoriesByVisitType: (type: string): Promise<{ data: string[] }> =>
    axios.get(`${axiosBaseUrl}/visit/types/categories-by-type`, {
      params: { type },
    }),
};
